module.exports = __webpack_public_path__ + "media/images/icons/search-5f52f0a909e59f60b1f472d625a685f3.svg";